import { useBreadcrumb } from "core/features/breadcrumbs";
import ListaReservas from "./components/ListaReservas";
import Container from "components/Container";

function ReservaListagemPage() {
  useBreadcrumb([{ name: "Administração" }, { name: "Reservas" }]);

  return (
    <Container>
      <ListaReservas />
    </Container>
  );
}

export default ReservaListagemPage;
